/** Shared colors for the copied V1 field/zone visualizations. */
export const STROKE_FILL = "#6B7280"; // gray-500
export const BALL_FILL = "#5BD07A";
